import { Component, computed, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Especialidad } from 'src/app/models/Especialidad';
import { UsuarioService } from 'src/app/services/usuario.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-especialidad',
    templateUrl: './especialidad.component.html',
    styleUrls: ['./especialidad.component.css'],
    standalone: false
})
export class MoreEspecialidadComponent {
  private _usuarioService = inject(UsuarioService);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);
  private router = inject(Router);
  private _location = inject(Location);

  // estado
  error   = signal<string>('');
  loading = computed(() => this._loadingService.isLoading());

  moreEspecialidad!: FormGroup;
  id?: number;
  operacion: string = "Agregar ";
  botonOperacion: string = "Agregar ";

  constructor(private fb: FormBuilder, 
    private aRoute: ActivatedRoute){
      this.createForm();
      this.id = Number(this.aRoute.snapshot.paramMap.get('id'));
  }

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    // Si necesitás (re)cargar usuario/cliente desde backend, hacelo bajo el loader:
    await this._loadingService.run(async () => {
      try {
        // Asegura bootstrap de sesión (idempotente, ok en web/nativo)
        await this._authService.ensureSession();

        // 2) Si es edición, cargo la especialidad
        if(this.id != 0){
          // Es editar
          this.operacion = "Editar ";
          this.botonOperacion = "Actualizar ";
          const res = await firstValueFrom(this._usuarioService.getEspecialidad(this.id!));

          if (!res) {
            // No existe => no tiene sentido editar
            this.error.set('La especialidad no existe o fue eliminada.');
            this.router.navigate(['/more-especialidades']);
            return;
          }

          this.moreEspecialidad.patchValue({
            descripcion: res?.x_descripcion ?? '',
            tags:  res?.x_tags ?? ''
          });
        }
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this.router.navigate(['/sign-in']);
      }
    });
  }

  createForm() {
    this.moreEspecialidad = this.fb.group({
      descripcion: ['', Validators.required ],
      tags: ['']
    });
  }

  async saveEspecialidad(){
    // Evita doble submit si ya está cargando
    if (this.loading()) return;

    this.error.set("");
    const { descripcion, tags } = this.moreEspecialidad.getRawValue();
    if (!descripcion?.trim()) {
      this.error.set('Debe completar la Descripción');
      return;
    }
    if (this.moreEspecialidad.invalid) {
      this.error.set('Revisá los campos requeridos.');
      return;
    }

    const especialidad: Especialidad = {
      id: this.id !== 0 ? this.id : undefined,
      x_descripcion: String(descripcion).trim(),
      x_tags: String(tags).trim(),
    };

    try {
      await this._loadingService.run(async () => {
        if (this.id !== 0) {
          // Editar
          await firstValueFrom(this._usuarioService.updateEspecialidad(especialidad));
        } else {
          // Crear
          await firstValueFrom(this._usuarioService.createEspecialidad(especialidad));
        }
      });

      await this.router.navigate(['/more-especialidades']);
    } catch (e) {
      console.error(e);
      this.error.set(this.id !== 0
        ? 'Error al actualizar la Especialidad'
        : 'Error al agregar la Especialidad');
    }
  }

  back(){
    this._location.back();
  }
}
